import React, { Component, Fragment } from 'react';
import { Paper, type Theme } from '@mui/material';

import {cyan, grey, pink, purple, orange, yellow, blue} from '@mui/material/colors';
import Grid from '@mui/material/Grid';
import {
  Assessment,Face,ThumbUp,
  ShoppingCart,AddShoppingCart,RemoveShoppingCart,
  Wifi,WifiOff,Work,Today,DateRange,AccessTime,PieChart,Payment,Assignment,LocalShipping,ListAlt,FileUpload,Autorenew,
  CheckCircle,
  VolunteerActivism,
  Celebration,
  Group
} from '@mui/icons-material'; 

import InfoBox from '../dashlibs/Info';
import Daily from '../dashlibs/Daily';
import Recent from '../dashlibs/Recent';
import Monthly from '../dashlibs/Monthly';
import Distribution from '../dashlibs/Distribution';
//import { ProgressDialog } from '../dialogs';

//import moment from 'moment';
import L, { LatLngBoundsExpression } from 'leaflet';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

//import {apipost, bizpost} from '../../ajax';
import { LatLngExpression } from 'leaflet';
import Map from '../dashlibs/Map';
import Anim from '../dashlibs/Anim';

const s:any = {
  root: {
    flexGrow: 1,
  },
  navigation: {
    fontSize: 15,
    fontWeight: 300,
    color: grey['600'],
    paddingBottom: 15,
    display: 'block'
  },
  title: {
    fontSize: 24,
    fontWeight: 300,
    marginBottom: 20,
    color:'white'
  },
  paper: {
    padding: 30
  },
  clear: {
    clear: 'both'
  },

  maproot: {
    flexGrow: 1,
    flexShrink: 1,
  },
  mapboardpaper: {
    backgroundColor: 'white',
    //maxHeight: 600,
    height: '100%',
    // height: 150
    marginLeft: 10,
    marginRight: 10,
  },
  mapdiv: {
    // height: 95,
    //padding: '5px 15px 0 15px'
  },
  mapheader: {
    fontSize: 24,
    fontWeight: 'typography.fontWeightLight',
    color: 'white',
    backgroundColor: purple['600'],
    padding: 10,
  }
};

let DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow
});

L.Marker.prototype.options.icon = DefaultIcon;

const icons:any = {
  Assessment,Face,ThumbUp,
  ShoppingCart,AddShoppingCart,RemoveShoppingCart,Assignment,Payment,Autorenew,FileUpload,ListAlt,
  Wifi,WifiOff,Work,Today,DateRange,AccessTime,PieChart,CheckCircle,LocalShipping,VolunteerActivism,Group,Celebration
};

// const icons:any = {
//   Assessment,Face,ThumbUp,
//   Assignment,Payment,AddShoppingCart,RemoveShoppingCart,
//   Wifi,WifiOff,Work,Today,DateRange,AccessTime,PieChart,FileUpload,ListAlt,LocalShipping,Autorenew
// };

class Activity extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);

    const {mapper={}} = this.props;
    const {cc} = mapper;
    const mcenter:LatLngExpression = cc || [8.977850, 39.253099];
    const mpos:LatLngExpression = cc || [9.01055, 38.74750];
    const mtext = `NTRMS. <br /> Event Location.`;
    const mbounds:LatLngBoundsExpression = [[4.71046214438, -3.24437008301],[11.0983409693, 1.0601216976]];
    const mzoom = 14;

    //const {count} = this.props;

    this.state = {
      dd: this.props.dd,
      ping: null,
      timer: 20000, //300000,
      count:0,
      loading: false,
      isFiltered: false, 

      mapping: null,
      maptimer: 60000,
      //mapcount:0,

      mcenter,
      mbounds,
      mpos,
      mtext,
      mzoom,

      lastread: null,
      recordset: [],
      previousset:[],
      currentset:[]
    };
  }

  componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any): void {
    try{
      const {count:ocount,recordset:ps} = prevState;
      const {count:ncount,mapper} = this.props;
      if(ncount > ocount){
        console.log('there is update...',ocount,ncount);
      }
      else {
        //console.log('no new update. stop processing');
        return;
      }
      //
      const {cc,rc,sd:cs} = mapper;
      if(rc === 0) {
        this.setState({count:ncount});
        return;
      }
      const title = 'Event Map';
      const ns = this.merge('mno',ps,cs);
      //
      const mcenter:LatLngExpression = cc; 
      const mpos:LatLngExpression = cc; 
      const mtext = `NTRMS Event. <br /> Event Location.`;
      const mbounds:LatLngBoundsExpression = [[4.71046214438, -3.24437008301],[11.0983409693, 1.0601216976]];
      const mzoom = 14;
    
      this.setState({count:ncount,rc,recordset:ns,previousset:ps,currentset:cs,title,mcenter,mbounds,mzoom,mpos,mtext,});
      
    }
    catch(err){
      console.log(err)
    }
      
  }

  merge = (p:string, ...arrs:any[]) => [].concat(...arrs).reduce((a, b) => !a.filter(c => b[p] === c[p]).length ? [...a, b] : a, []);


  render() {
    const {theme} = this.props;
    //const { loading} = this.state;
    const {infos,dists,daily,monthly,recent} = this.props;
    const {recordset,title,mcenter,mbounds,mzoom,mpos,mtext} = this.state;

    return (
      <>
      <Fragment>
        <Grid container spacing={{ xs:1, sm:3}}>
          {infos.map((info:any,idx:number) => (
            (info.title === 'OTHERS' && !info.value)?'':
          <Grid key={`infobox_${idx}`} size={{xs:12,sm:6,md:3,lg:3,xl:1}}>
            <InfoBox Icon={icons[info.icon]}
                    color={info.color}
                    title={info.title}
                    value={info.value||0}/>
          </Grid>
          ))
          }
        </Grid>
        <Grid  container spacing={{ xs:1, sm:3}}>
          <Grid size={{xs:12,sm:6}}>
            <Recent data={recent||[]} title='Recent Logins' icons/>
          </Grid>
          <Grid size={{xs:12,sm:6}}>
            <Daily data={daily||[]} title='Daily Logins' icons/>
          </Grid>
          {/* <Grid size={{xs:12,sm:6}}>
            <Monthly data={monthly||[]} title='Monthly Logins' icons/>
          </Grid> */}
          {/* {dists.map((dist:any,idx:number) => (
          <Grid key={`dist_${idx}`} size={{xs:12,sm:6}}>
            <Distribution data={dist.data||[]} title={dist.title} color={dist.color} icons/>
          </Grid>
          ))
          } */}
        </Grid>
        {/* <Grid container spacing={{ xs:1, sm:3}}>
          <Grid size={{xs:12}}>
            <Map 
              recordset={recordset} 
              title={title} 
              mapcenter={mcenter} 
              mapbounds={mbounds} 
              mapzoom={mzoom} 
              mappos={mpos} 
              maptext={mtext}
              markerpos={mpos} 
              markertext={mtext}
            />
          </Grid>
        </Grid> */}

      </Fragment>
      </>
    );
  }
};

export default Activity;
